/**
 * Le pluriel arabe, en quatre formes : un, deux, de trois a dix, puis
 * au-dela. `un` et `deux` s'ecrivent sans le nombre, comme en arabe.
 */
export function compte(n: number, un: string, deux: string, peu: string, beaucoup: string): string {
  if (n === 1) return un;
  if (n === 2) return deux;
  return `${n} ${n >= 3 && n <= 10 ? peu : beaucoup}`;
}
